import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';

import moduleInfo from '../module.json';
import { registerMagsnabWelcomeExtensions } from './extensions/MagsnabWelcomeExtension';

/**
 * Регистрация клиентской части инстанса magsnab.
 */
export async function setup(app: AppRuntime): Promise<void> {
  app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  // Карточка «Avito: Сообщения» на главной (велком).
  registerMagsnabWelcomeExtensions();
}
